/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  whiteSpace: "nowrap",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style, fontWeight: row?.bold ? "bold" : 400 }}>
      {children}
    </td>
  );
};

const TdWithRowSpan = ({ row, value1, value2 }) => {
  return (
    <Td
      style={{
        textAlign: !value2 ? "left" : "center",
        width: "100%",
        display: !value2 ? "table-cell" : "flex",
        alignItems: "center",
        border: "none",
        padding: !value2 ? 8 : 0,
        height: "100%",
        borderBottom: !value2 ? "1px solid black" : "none",
        background: !row.title.bg ? "transparent" : "#ddeff3",
      }}
    >
      {!value2 && value1}
      {value2 && (
        <>
          <div
            style={{
              textAlign: "center",
              width: "100px",
              borderRight: "1px solid black",
              height: "100%",
              padding: 8,
              borderBottom: "1px solid black",
              whiteSpace: "nowrap",
            }}
          >
            {value1}
          </div>
          <div
            style={{
              textAlign: "left",
              width: "calc(100% - 100px)",
              height: "100%",
              padding: 8,
              borderBottom: "1px solid black",
              whiteSpace: "nowrap",
            }}
          >
            {value2}
          </div>
        </>
      )}
    </Td>
  );
};

const dataTable = [
  {
    onlyTitle: true,
    bold: true,
    index: {
      value: "I",
      bg: true,
    },
    id: {
      value: null,
      bg: true,
    },
    currency: {
      value: null,
      bg: false,
    },
    title: {
      value: "Doanh thu từ hoạt động đại lý xổ số",
      bg: true,
    },
  },
  {
    bold: false,
    index: {
      value: "1",
      bg: false,
    },
    id: {
      value: 20,
      bg: false,
    },
    currency: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Tổng thu nhập chịu thế phát sinh trong kỳ",
      bg: false,
    },
  },
  {
    bold: false,
    index: {
      value: "2",
      bg: false,
    },
    id: {
      value: 21,
      bg: false,
    },
    currency: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Trong đó: Thu nhập chịu thuế được miễn giảm theo Hiệp định",
      bg: false,
    },
  },
  {
    isRowSpan: true,
    index: {
      value: "3",
      bg: true,
      rowSpan: 7,
    },
  },
  {
    id: {
      value: 22,
      bg: true,
    },
    currency: {
      value: 0,
      bg: true,
    },
    title: {
      value1: "Tổng các khoản giảm trừ ([22]=[23]+[24]+[25]+[26]+[27])",
      bg: true,
    },
  },
  {
    id: {
      value: 23,
      bg: false,
    },
    currency: {
      value: 0,
      bg: false,
    },
    title: {
      value1: "a",
      value2: "Cho bản thân",
      bg: false,
    },
  },
  {
    id: {
      value: 24,
      bg: false,
    },
    currency: {
      value: 0,
      bg: false,
    },
    title: {
      value1: "b",
      value2: "Cho người phụ thuộc",
      bg: false,
    },
  },
  {
    id: {
      value: 25,
      bg: false,
    },
    currency: {
      value: 0,
      bg: false,
    },
    title: {
      value1: "c",
      value2: "Cho từ thiện, nhân đạo, khuyến học",
      bg: false,
    },
  },
  {
    id: {
      value: 26,
      bg: false,
    },
    currency: {
      value: 0,
      bg: false,
    },
    title: {
      value1: "d",
      value2: "Các khoản đóng bảo hiểm được trừ",
      bg: false,
    },
  },
  {
    id: {
      value: 27,
      bg: false,
    },
    currency: {
      value: 0,
      bg: false,
    },
    title: {
      value1: "e",
      value2: "Khoản đóng quỹ hưu trí tự nguyên được trừ",
      bg: false,
    },
  },
  {
    bold: false,
    index: {
      value: "4",
      bg: true,
    },
    id: {
      value: 28,
      bg: true,
    },
    currency: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Tổng thu nhập thuế ([28]= [20]-[21]-[22])",
      bg: true,
    },
  },
  {
    bold: false,
    index: {
      value: "5",
      bg: true,
    },
    id: {
      value: 29,
      bg: true,
    },
    currency: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Tổng số thuế thu nhập cá nhân phát sinh trong kỳ",
      bg: true,
    },
  },
  {
    onlyTitle: true,
    bold: true,
    index: {
      value: "II",
      bg: true,
    },
    id: {
      value: null,
      bg: true,
    },
    currency: {
      value: null,
      bg: false,
    },
    title: {
      value: "Cá nhân không cư trú có thu nhập từ tiền lương, tiền công:",
      bg: true,
    },
  },
  {
    bold: false,
    index: {
      value: "1",
      bg: false,
    },
    id: {
      value: 30,
      bg: false,
    },
    currency: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Tổng thu nhập tính thuế",
      bg: false,
    },
  },
  {
    bold: false,
    index: {
      value: "2",
      bg: true,
    },
    id: {
      value: 31,
      bg: true,
    },
    currency: {
      value: "20%",
      bg: true,
    },
    title: {
      value: "Mức thuế suất",
      bg: true,
    },
  },
  {
    bold: false,
    index: {
      value: "3",
      bg: true,
    },
    id: {
      value: 32,
      bg: true,
    },
    currency: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Tổng số thuế thu nhập cá nhân phải nộp ([32]=[30]x[31])",
      bg: true,
    },
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }}>STT</Th>
              <Th style={{ textAlign: "center" }}>Chi tiêu</Th>
              <Th style={{ textAlign: "center" }}>Mã chi tiêu</Th>
              <Th style={{ textAlign: "center", minWidth: 200 }}>Số tiền</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => {
                if (row.isRowSpan) {
                  return (
                    <tr key={row?.id?.value + index}>
                      <Td
                        rowSpan={row.index.rowSpan}
                        style={{
                          textAlign: "center",

                          background: !row.index.bg ? "transparent" : "#ddeff3",
                        }}
                      >
                        {row.index.value}
                      </Td>
                    </tr>
                  );
                }
                if (!row?.index?.value) {
                  return (
                    <tr key={row?.id?.value + index}>
                      <TdWithRowSpan
                        row={row}
                        value1={row.title.value1}
                        value2={row.title.value2}
                      />
                      <Td
                        style={{
                          textAlign: "center",
                          background: !row.id.bg ? "transparent" : "#ddeff3",
                        }}
                      >
                        [{row.id.value}]
                      </Td>
                      <Td
                        row={row}
                        style={{
                          textAlign: "right",
                          padding: 8,
                          paddingRight: row.currency.bg ? 12 : 8,
                          background: !row.currency.bg ? "transparent" : "#ddeff3",
                        }}
                      >
                        {row.currency.bg ? (
                          row.currency.value
                        ) : (
                          <InputTable
                            id={row.id.value}
                            name="currency"
                            value={row.currency.value}
                            onChange={handleChange}
                          />
                        )}
                      </Td>
                    </tr>
                  );
                }
                return (
                  <TdNormal
                    key={row?.id?.value + index}
                    row={row}
                    index={index}
                    handleChange={handleChange}
                  />
                );
              })}
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

const TdNormal = ({ row, index, handleChange }) => {
  return (
    <tr key={row.index.value + index}>
      <Td
        rowSpan={row.index.rowSpan ?? 1}
        row={row}
        style={{
          textAlign: "center",
          background: !row.index.bg ? "transparent" : "#ddeff3",
        }}
      >
        {row.index.value}
      </Td>
      <Td
        row={row}
        colSpan={row.onlyTitle ? 4 : 1}
        style={{
          textAlign: "left",
          background: !row.index.bg ? "transparent" : "#ddeff3",
          borderTop: "none",
        }}
      >
        {row.title.value}
      </Td>
      {!row.onlyTitle && (
        <>
          <Td
            row={row}
            style={{
              textAlign: "center",
              background: !row.id.bg ? "transparent" : "#ddeff3",
            }}
          >
            [{row.id.value}]
          </Td>
          <Td
            row={row}
            style={{
              textAlign: "right",
              background: !row.currency.bg ? "transparent" : "#ddeff3",
            }}
          >
            {row.currency.bg ? (
              row.currency.value
            ) : (
              <InputTable
                id={row.id.value}
                name="currency"
                value={row.currency.value}
                onChange={handleChange}
              />
            )}
          </Td>
        </>
      )}
    </tr>
  );
};
